module KendoWidgets
{
	export class TimePickerOptions implements kendo.ui.TimePickerOptions
	{
		name?: string;
		animation?: boolean | kendo.ui.TimePickerAnimation;
		culture?: string;
		dateInput?: boolean;
		dates?: any;
		format?: string;
		interval?: number;
		max?: Date;
		min?: Date;
		parseFormats?: any;
		value?: Date;

		label?: string;
		labelPosition?: LabelPositionEnum;
		labelClass?: string;
		labelWidth?: number;

		width?: string | number;
		css?: string;
		enabled?: boolean;

		change?(e: kendo.ui.TimePickerChangeEvent): void;
		close?(e: kendo.ui.TimePickerCloseEvent): void;
		open?(e: kendo.ui.TimePickerOpenEvent): void;
	}

	export class TimePicker extends kendo.ui.TimePicker implements KendoWidget
	{
		public controlType(): ControlTypeEnum { return ControlTypeEnum.TimePicker; }
		private _firstLoad: boolean;
		private _isChangingTime: boolean;

		constructor(element: Element, options?: KendoWidgets.TimePickerOptions)
		{
			if (options == null)
				options = new KendoWidgets.TimePickerOptions();

			if (options.enabled == null) options.enabled = true;
			if (options.width == null) options.width = 87;
			options.dateInput = false;
			if (options.culture == null) options.culture = "it-IT";

			//#region Width
			if (typeof (options.width) == "number")
				options.width = options.width + "px";

			(element as HTMLElement).style.cssText += "width: " + options.width;
			//#endregion
			super(element, options);
			let that = this;

			element.parentElement!.parentElement!.id = element.id + "Parent";
			$(element).parent().parent().addClass("controlParent");

			//#region CSS
			if (options.css != null)
				(element as HTMLElement).parentElement!.parentElement!.style.cssText += options.css;
			//#endregion

			//#region Enabled
			if (!options.enabled)
				this.enable(false);
			//#endregion

			//#region Label
			if (options.label != null && !this._firstLoad)
			{
				this._firstLoad = true;

				$("#" + element.id + "Label").remove();
				let label = document.createElement("label");
				label.id = element.id + "Label";
				$(label).kendoLabel(
					{
						text: options.label,
						color: KendoWidgets.ColorEnum.BlueVettore,
						class: options.labelClass,
						height: 21,
						fontSize: 14,
						width: (options.labelWidth != null) ? options.labelWidth : "auto"
					});

				//#region Label position
				if (options.labelPosition == null) options.labelPosition = LabelPositionEnum.Top;
				switch (options.labelPosition)
				{
					case LabelPositionEnum.Top:
						{
							$(label).addClass("k-label-top");
							element.parentElement!.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.parentElement!.insertBefore(label, element.parentElement!.parentElement!.firstChild);
						}
						break;
					case LabelPositionEnum.Left:
						{
							$(label).addClass("k-label-left");
							element.parentElement!.parentElement!.insertBefore(label, element.parentElement!.parentElement!.firstChild);
							label.style.cssText += "margin-right: 5px";

							if (options.width != "100%" && typeof (options.width) === "number")
								$(element).closest(".k-timepicker")[0].style.cssText += "width: " + (label.clientWidth + options.width) + "px";
						}
						break;
					case LabelPositionEnum.Right:
						{
							$(label).addClass("k-label-right");
							element.parentElement!.parentElement!.append(label);
							label.style.cssText += "margin-left: 5px";
						}
						break;
					case LabelPositionEnum.Bottom:
						{
							$(label).addClass("k-label-bottom");
							element.parentElement!.parentElement!.style.cssText += "display: inline-flex; flex-direction: column;";
							element.parentElement!.parentElement!.append(label);
						}
						break;
				}
				//#endregion
			}
			//#endregion

			//#region Real date input
			$(element).keydown((e) =>
			{
				that._isChangingTime = true;
				that.element.parent().css("border", "solid 1px #CCC");
			});
			$(element).keyup((e) =>
			{
				if (e.keyCode == 13)
					that.formatDateInput((e.target as HTMLInputElement).value)
			});
			$(element).blur((e) => that.formatDateInput((e.target as HTMLInputElement).value));
			//#endregion
		}

		//#region Time input
		private formatDateInput(inputText: string)
		{
			if (inputText.length == 0 || this._isChangingTime)
				return;

			inputText = inputText.replace(/[^\w\s]/gi, '');
			inputText = inputText.replace(/\s/g, '');
			let inputTextNumeric = parseFloat(inputText);

			let today = new Date();
			today.setHours(0, 0);
			let hoursNow = new Date().getHours();
			let minutesNow = new Date().getMinutes();

			//#region Special
			switch (inputText.toLowerCase())
			{
				case "adesso": this.value(new Date()); return;
				case "pumo": { this.value(new Date(1993, 9, 10, 10, 10)); } return;
			}
			//#endregion

			//#region Normal use
			if (inputText.length == 1 || inputText.length == 3)
				inputText = "0" + inputText;

			if (inputText.length == 2)
				this.value(today.addHours(inputTextNumeric));
			else if (inputText.length == 4)
			{
				let hours = parseFloat(inputText[0] + inputText[1]);
				let minutes = parseFloat(inputText[2] + inputText[3]);
				this.value(today.addHours(hours).addMinutes(minutes));
			}
			//#endregion

			(this.options as KendoWidgets.DatePickerOptions).isChangingDate = false;
		}
		//#endregion

		visible(visibleStatus?: boolean)
		{
			if (visibleStatus != null)
			{
				if (visibleStatus)
					this.element.parent().parent().show();
				else
					this.element.parent().parent().hide();
			}

			return this.element.parent().parent().is(":visible");
		}

		clear()
		{
			this.value("");
		}

		disable()
		{
			this.enable(false);
		}

		value(date?: Date | string | null)
		{
			if (date != null)
			{
				if (typeof (date) == "string")
				{
					if (date !== "")
						date = Date.fixDateString(date);
				}

				super.value(date as any);
			}

			return super.value();
		}

		isEmpty()
		{
			return (this.value() == null);
		}

		focus()
		{
			this.element.focus();
		}

		appendTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().parent().appendTo(element);
		}

		prependTo(element: string | HTMLElement | JQuery)
		{
			this.element.parent().parent().prependTo(element);
		}
	}

	TimePicker.fn = TimePicker.prototype;
	TimePicker.fn.options = $.extend(true, {}, kendo.ui.TimePicker.fn.options);
	TimePicker.fn.options.name = "TimePicker";
	kendo.ui.plugin(TimePicker);
}

interface JQuery
{
	kendoTimePicker(options?: KendoWidgets.TimePickerOptions): JQuery;
}